import React,{useEffect} from'react';
import {useHistory } from "react-router-dom";
import {ArrowLeftSquare} from "react-bootstrap-icons";
import momentJalaali from "moment-jalali";

export default function BackButton() {
  const [today, setDate] = React.useState(momentJalaali());
  useEffect(() => {
    const timer = setInterval(() => { 
    setDate(momentJalaali());
  }, 60 * 1000);
  return () => {
    clearInterval(timer);
  }
}, []);
  let history = useHistory();
  function handleClick() {
  
     history.goBack();
  }

  return (
    <div style={{maxHeight:"20px", position:"absolute", top:"0", left:"0"}}>
    <ArrowLeftSquare id="BackBtn" onClick={handleClick} size={32}style={{float:"left", marginLeft:"12px", color:"rgb(82, 75, 210)", display:"none"}} className="backArrow mt-2"/>
    <span id="NowTime" style={{float:"left", marginTop:"17px", marginLeft:"10px", color:"white", direction:"ltr"}}>{today.format("jYYYY/jMM/jDD HH:mm")}</span>
    </div>
  );
}